import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i2 from '@pv-frontend/pv-shared-directives/tracking';
import { ClickTrackingModule } from '@pv-frontend/pv-shared-directives/tracking';
import * as i1 from 'primeng/button';
import { ButtonModule } from 'primeng/button';

class ButtonComponent {
    constructor() {
        this.style = {};
        this.styleClass = '';
        this.variant = 'contained';
        this.isRounded = false;
        this.isDisabled = false;
        this.isLoading = false;
        this.type = 'button';
        this.size = 'medium';
        this.label = '';
        this.analyticsEnabledForButton = false;
        this.labelForAnalytics = '';
        this.clickEvent = new EventEmitter();
        this.buttonSizes = {
            small: 'p-button-sm',
            medium: 'p-button',
            large: 'p-button-lg',
        };
        this.buttonVariants = {
            link: 'p-button-link font-bold',
            contained: 'p-button-raised font-bold',
            outlined: 'p-button-outlined font-bold',
            text: 'p-button-text font-bold',
        };
    }
    ngOnChanges() {
        this.buttonSizeClass = this.buttonSizes[this.size];
        this.roundedClass = this.isRounded ? 'p-button-rounded' : '';
        this.variantClass = this.buttonVariants[this.variant];
    }
    handleClick(event) {
        event.stopPropagation();
        event.preventDefault();
        if (!this.isDisabled) {
            this.clickEvent.emit(event);
        }
    }
    getButtonClasses() {
        return `${this.variantClass} ${this.roundedClass} ${this.buttonSizeClass} flex align-items-center justify-content-center ${this.styleClass}`;
    }
}
ButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
ButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: ButtonComponent, selector: "pv-button", inputs: { style: "style", styleClass: "styleClass", variant: "variant", isRounded: "isRounded", isDisabled: "isDisabled", isLoading: "isLoading", type: "type", size: "size", label: "label", analyticsEnabledForButton: "analyticsEnabledForButton", labelForAnalytics: "labelForAnalytics" }, outputs: { clickEvent: "clickEvent" }, usesOnChanges: true, ngImport: i0, template: "<p-button\n  [styleClass]=\"getButtonClasses()\"\n  [type]=\"type\"\n  [label]=\"label\"\n  [loading]=\"isLoading\"\n  [disabled]=\"isDisabled\"\n  (click)=\"handleClick($event)\"\n  [style]=\"style\"\n  [pvClickTrack]=\"analyticsEnabledForButton\"\n  [pvTrackLabel]=\"labelForAnalytics\">\n  <ng-content></ng-content>\n</p-button>\n", styles: ["::ng-deep p-button:has(.p-element.p-disabled){cursor:not-allowed}\n"], dependencies: [{ kind: "component", type: i1.Button, selector: "p-button", inputs: ["type", "iconPos", "icon", "badge", "label", "disabled", "loading", "loadingIcon", "style", "styleClass", "badgeClass", "ariaLabel"], outputs: ["onClick", "onFocus", "onBlur"] }, { kind: "directive", type: i2.ClickTrackDirective, selector: "[pvClickTrack]", inputs: ["pvClickTrack", "pvTrackLabel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pv-button', template: "<p-button\n  [styleClass]=\"getButtonClasses()\"\n  [type]=\"type\"\n  [label]=\"label\"\n  [loading]=\"isLoading\"\n  [disabled]=\"isDisabled\"\n  (click)=\"handleClick($event)\"\n  [style]=\"style\"\n  [pvClickTrack]=\"analyticsEnabledForButton\"\n  [pvTrackLabel]=\"labelForAnalytics\">\n  <ng-content></ng-content>\n</p-button>\n", styles: ["::ng-deep p-button:has(.p-element.p-disabled){cursor:not-allowed}\n"] }]
        }], propDecorators: { style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], variant: [{
                type: Input
            }], isRounded: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], isLoading: [{
                type: Input
            }], type: [{
                type: Input
            }], size: [{
                type: Input
            }], label: [{
                type: Input
            }], analyticsEnabledForButton: [{
                type: Input
            }], labelForAnalytics: [{
                type: Input
            }], clickEvent: [{
                type: Output
            }] } });

class PvButtonModule {
}
PvButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PvButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PvButtonModule, declarations: [ButtonComponent], imports: [CommonModule, ButtonModule, ClickTrackingModule], exports: [ButtonComponent] });
PvButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvButtonModule, imports: [CommonModule, ButtonModule, ClickTrackingModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ButtonComponent],
                    imports: [CommonModule, ButtonModule, ClickTrackingModule],
                    exports: [ButtonComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ButtonComponent, PvButtonModule };
